export default function PHP_FileUpload() {
  return (
    <div>
      <h1>PHP_FileUpload</h1>
    </div>
  );
}
